import { useCookieConsent } from '../contexts/CookieConsentContext';

export const useCookieAwareEffect = () => {
  const { hasConsent } = useCookieConsent();

  return { hasConsent };
};